<template>
  <div>
    <el-dialog
      ref="addEditViewDialog"
      v-dialogDrag
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      class="h700_dialog abow_dialog"
      width="1200px"
      :before-close="modalClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
    >
      <el-form
        ref="dialogAddEditViewForm"
        :model="dialogAddEditViewForm"
        :rules="eventType==='view' ? null : dialogAddEditViewFormRules"
        class="add-edit-view-form"
        @submit.native.prevent
      >
        <div class="modal-box">
          <h3 class="modal-title">
            基础信息
          </h3>
          <div class="modal-row-box">
            <el-row :gutter="10">
              <el-col :span="6">
                <el-form-item label="省区">
                  <el-input
                    v-model="dialogAddEditViewForm.provinceName"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="城市">
                  <el-input
                    v-model="dialogAddEditViewForm.cityName"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  label="店名"
                  prop="storeName"
                >
                  <el-input
                    v-model="dialogAddEditViewForm.storeName"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  label="实际店名"
                  prop="realStoreName"
                >
                  <el-input
                    v-model="dialogAddEditViewForm.realStoreName"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="走访人">
                  <el-input
                    v-model="dialogAddEditViewForm.userName"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="检查日期">
                  <el-input
                    v-model="dialogAddEditViewForm.checkDate"
                    disabled
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :span="6">
                <el-form-item label="有无变更专卖证号">
                  <el-input
                    v-model="dialogAddEditViewForm.isChangeCertificateNoValue"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="原专卖证号">
                  <el-input
                    v-model="dialogAddEditViewForm.oldCertificateNo"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="新专卖证号">
                  <el-input
                    v-model="dialogAddEditViewForm.newCertificateNo"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col
                v-if="picList.length > 0"
                :span="6"
              >
                <div style="position: fixed;margin-top: 10px;width: 220px;height:218px;">
                  <show-preview :arr-file-data="picList" />
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :span="6">
                <el-form-item label="有无变更专卖证截止有效期">
                  <el-input
                    v-model="dialogAddEditViewForm.isChangeCertificateEndDateValue"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="原截止日期">
                  <el-input
                    v-model="dialogAddEditViewForm.oldEndDate"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="新截止日期">
                  <el-input
                    v-model="dialogAddEditViewForm.newEndDate"
                    disabled
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :span="6">
                <el-form-item label="有无变更档位">
                  <el-input
                    v-model="dialogAddEditViewForm.isChangeLevelValue"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="原档位">
                  <el-input
                    v-model="dialogAddEditViewForm.oldLevelName"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="新档位">
                  <el-input
                    v-model="dialogAddEditViewForm.newLevelName"
                    disabled
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :span="6">
                <el-form-item label="有无变更本香注册手机号">
                  <el-input
                    v-model="dialogAddEditViewForm.isChangeBenxiangPhoneValue"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="原本香注册手机号">
                  <el-input
                    v-model="dialogAddEditViewForm.oldBenxiangPhone"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="新本香注册手机号">
                  <el-input
                    v-model="dialogAddEditViewForm.newBenxiangPhone"
                    disabled
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :span="6">
                <el-form-item label="有无变更本香门店码">
                  <el-input
                    v-model="dialogAddEditViewForm.isChangeBenxiangStoreNoValue"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="原本香门店码">
                  <el-input
                    v-model="dialogAddEditViewForm.oldBenxiangStoreNo"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="新本香门店码">
                  <el-input
                    v-model="dialogAddEditViewForm.newBenxiangStoreNo"
                    disabled
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :span="6">
                <el-form-item label="有无变更邮寄地址">
                  <el-input
                    v-model="dialogAddEditViewForm.isChangeMailAddressValue"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="原邮寄地址">
                  <el-input
                    v-model="dialogAddEditViewForm.oldMailAddress"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="新邮寄地址">
                  <el-input
                    v-model="dialogAddEditViewForm.newMailAddress"
                    disabled
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-form>

      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="modalClose">
          关闭
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
// dialog 拖拽
import dialogDragMixin from '@/mixin/dialogDragMixin'
// 图片预览
import showPreview from '@/components/showPreview'
// 终端恢复申请API
import { viewStoreVisitCheckInfoApi } from '@/api/v2/storeVisitCheckInfo';

export default {
  components: { showPreview },
  mixins: [dialogDragMixin],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    eventType: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dataId: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      expandMoreData: false,
      dialogAddEditViewForm: {},
      dialogAddEditViewFormRules: {},
      picList: [],
      baseUrl: process.env.VUE_APP_BASE_API,
      nasUrl: process.env.VUE_APP_NAS_API
    }
  },
  watch: {
    dialogVisible (val) {
      if (val) {
        let _this = this;
        _this.picList = []
        _this.dialogAddEditViewForm = {}
        if (_this.eventType !== 'add') {
          _this.loadStoreVisitCheckInfoData();
        }

        _this.$nextTick(() => {
          _this.$refs.dialogAddEditViewForm.clearValidate()
        })
      }
    },
  },
  methods: {
    // 加载终端恢复申请数据
    loadStoreVisitCheckInfoData () {
      let _this = this;
      viewStoreVisitCheckInfoApi({ id: _this.dataId }).then((response) => {
        const { data } = response;
        _this.dialogAddEditViewForm = data
        
        if(data.certificatePic && data.certificatePic.length > 0){
          let nasYearMonth = Number(new Date().getFullYear() - 1) + '12'
          let yearMonth = data.certificatePic.split('/')[2].substring(0,6)
          let obj = {}
          obj.name = data.certificatePic
          if(Number(nasYearMonth) > Number(yearMonth)){
            obj.url = _this.nasUrl + data.certificatePic
          } else {
            obj.url = _this.baseUrl + data.certificatePic
          }
          obj.attachmentName = data.certificatePic
          obj.attachmentUrl = data.certificatePic
          _this.picList.push(obj)
        }
      })
    },
    modalClose () {
      let _this = this;
      _this.$emit('update:dialogVisible', false);
      _this.imageFileList = [];
      _this.$refs.dialogAddEditViewForm.clearValidate();
    }
  }
}
</script>
<style lang="scss" scoped>
</style>
